// ------------------------------------
// Configurações Gerais
// ------------------------------------

// Informações do site
const $infosBase = $('#infos-base');
const urlBase = $infosBase.data('base-url'); // URL base do site
const pagBase = $infosBase.data('base-pag'); // Página atual
const baseStore = $infosBase.data('store'); // Slug da loja
const baseTheme = $infosBase.data('theme'); // Tema
const baseTemplate = $infosBase.data('template'); // Template
const publicToken = $infosBase.data('token'); // Token
const baseLanding = $infosBase.data('lp'); // ID da Landing Page
const urlBaseLp = $infosBase.data('lp-url'); // Url base da Landing Page
const tipoBaseLp = $infosBase.data('lp-tipo'); // Tipo da Landing Page
const baseProduct = $infosBase.data('product'); // ID do produto
const baseProductURL = $infosBase.data('product-url'); // URL do produto
const userOnPagParam = $infosBase.data('user-on-pag-param'); // Página de parâmetro para os usuários online (landing/checkout)
const recaptchaKey = $infosBase.data('recaptcha-key') || '';
const editorType = $infosBase.data('editor-type'); // Tipo de editor (store, landing, checkout)

// Objeto Global
window.LPQV = window.LPQV || {};
if (window.LPQV && typeof window.LPQV === 'string') {
  try {
    window.LPQV = JSON.parse(window.LPQV);
  } catch (error) {
    console.log(error);
    window.LPQV = {};
  }
}
